/*
 * @Descripttion:
 * @version:
 * @Author: dengyao
 * @Date: 2023-11-27 13:33:12
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-01-08 13:30:36
 */

import request from '../request'
import { ILoginParams, IUpdatePwdParams } from '../model'

enum Api {
  GET_ORDER_LIST = '/orderParcel/page',
  GET_ORDER_DETAIL = '/orderParcel/detail',
  GET_ORDER_SOURCE = '/orderParcel/source',
  GET_EXPRESS_COMPANY = '/express/expressList',
  GET_ENUMERATE_LIST = '/enum/queryList',
  CANCEL_ORDER = '/orderParcel/cancelOrder',
  BATCH_HANDOVER = '/orderParcel/orderHandover',
  ORDER_LIST_EXPORT_FILE = '/orderParcel/export',
  GET_SERVICE_TYPE_LIST = '/orderParcel/serviceTypeCheck',
  GET_TOTAL_COST_MONEY = '/orderParcel/totalCostMoney',
  SEARCH_CUSTOMER_CODE = '/orderParcel/customerCheck',
  GET_QUOTETYPE_LIST = '/orderParcel/quoteTypeList',
  DISCOUNT_COUPON_CHECK = '/orderParcel/discountCouponCheck',
  GET_COST_AGGREGATION = '/orderParcel/costAggregation',
  PLACE_ORDER = '/orderParcel/placeOrder',
  PRINT_ORDER_FOR_ID = '/orderParcel/printOrder',
  QUICK_PRINTING_SACN = '/orderParcel/quickPrintingScan',
  QUICK_PRINTING = '/orderParcel/quickPrinting'
}

export default class orderService {
  /**
   * 获取订单列表
   * @param data
   * @returns
   */
  static getOrderList(data: ILoginParams): Promise<any> {
    return request.post(Api.GET_ORDER_LIST, data)
  }

  /**
   * 获取订单详情
   * @param data
   * @returns
   */
  static getOrderDetail(data: any): Promise<any> {
    return request.post(Api.GET_ORDER_DETAIL, data)
  }

  /**
   * 获取订单来源
   * @param data
   * @returns
   */
  static getOrderSource(): Promise<any> {
    return request.get(Api.GET_ORDER_SOURCE)
  }

  /**
   * 获取快递公司
   * @param data
   * @returns
   */
  static getExpressCompany(): Promise<any> {
    return request.post(Api.GET_EXPRESS_COMPANY)
  }

  /**
   * 根据枚举名称查询枚举选项
   * @param data
   * @returns
   */
  static getEnumerateList(data: any): Promise<any> {
    return request.post(Api.GET_ENUMERATE_LIST, data)
  }

  /**
   * 取消订单
   * @param data
   * @returns
   */
  static cancelOrder(data: any): Promise<any> {
    return request.post(Api.CANCEL_ORDER, data)
  }

  /**
   * 批量交接
   * @param data
   * @returns
   */
  static batchHandover(data: any): Promise<any> {
    return request.post(Api.BATCH_HANDOVER, data)
  }

  /**
   * 订单列表分页导出
   * @param data
   * @returns
   */
  static orderListExportFile(data: any): Promise<any> {
    return request.post(Api.ORDER_LIST_EXPORT_FILE, data, true)
  }

  /**
   * 获取产品类型
   * @param data
   * @returns
   */
  static getServiceTypeList(data: any): Promise<any> {
    return request.post(Api.GET_SERVICE_TYPE_LIST, data)
  }

  /**
   * 获取报价类型
   * @param data
   * @returns
   */
  static getQuoteTypeList(data: any): Promise<any> {
    return request.post(Api.GET_QUOTETYPE_LIST, data)
  }

  /**
   * jms算费
   * @param data
   * @returns
   */
  static getTotalCostMoney(data: any): Promise<any> {
    return request.post(Api.GET_TOTAL_COST_MONEY, data)
  }

  /**
   * 查询大客户编码
   * @param data
   * @returns
   */
  static searchCustomerCode(data: any): Promise<any> {
    return request.post(Api.SEARCH_CUSTOMER_CODE, data)
  }

  /**
   * 优惠券校验（散单）
   * @param data
   * @returns
   */
  static discountCouponCheck(data: any): Promise<any> {
    return request.post(Api.DISCOUNT_COUPON_CHECK, data)
  }

  /**
   * 费用汇总
   * @param data
   * @returns
   */
  static getCostAggregation(data: any): Promise<any> {
    return request.post(Api.GET_COST_AGGREGATION, data)
  }

  /**
   * 新增or编辑订单
   * @param data
   * @returns
   */
  static placeOrder(data: any): Promise<any> {
    return request.post(Api.PLACE_ORDER, data)
  }

  /**
   * 根据id打印面单
   * @param data
   * @returns
   */
  static printOrderForId(data: any): Promise<any> {
    return request.post(Api.PRINT_ORDER_FOR_ID, data)
  }

  /**
   * 快速打印扫描
   * @param data
   * @returns
   */
  static quickPrintingScan(data: any): Promise<any> {
    return request.post(Api.QUICK_PRINTING_SACN, data)
  }

  /**
   * 快速打印（打印面单）
   * @param data
   * @returns
   */
  static quickPrinting(data: any): Promise<any> {
    return request.post(Api.QUICK_PRINTING, data)
  }
}
